export const en = {
    // Navbar & Sidebar
    navigation: {
        dashboard: 'Dashboard',
        agents: 'My Agents',
        masterAgents: 'Master Management',
        agentPerformance: 'Agent Performance',
        rules: 'Payment Rules',
        mappings: 'Column Mappings',
        consolidation: 'Consolidation',
        processor: 'Process Commissions',
        reconciliation: 'Reconciliation',
        unassigned: 'Unregistered Agents',
        subscription: 'Subscription',
        profile: 'My Account',
        clientsActive: 'All Active Clients',
        clientsCanceled: 'All Canceled Clients',
        clients: 'Clients',
        bookOfBusiness: 'Book of Business',
        dailyActivity: 'Daily Activity',
        tasks: 'Tasks & Notes',
        messagesMenu: 'Messages',
        bookUpload: 'Upload Book of Business',
        myDashboard: 'My Dashboard',
        myClients: 'My Clients',
        myReconciliation: 'My Reconciliation',
        myAgency: 'My Agency',
        independent: 'Independent',
        login: 'Log In',
        logout: 'Log Out',
        home: 'Home',
        agency: 'Agency',
        payments: 'Agent Payments',
        settings: 'Default Settings'
    },
    // Dashboard
    dashboard: {
        title: 'Command Center',
        subtitle: 'Global financial view',
        months: {
            1: 'January', 2: 'February', 3: 'March', 4: 'April', 5: 'May', 6: 'June',
            7: 'July', 8: 'August', 9: 'September', 10: 'October', 11: 'November', 12: 'December'
        },
        noData: 'No data in this period',
        stats: {
            grossRevenue: 'Gross Revenue',
            agentPayout: 'Agent Payout',
            netRevenue: 'Net Revenue',
            policiesMembers: 'Policies / Members'
        },
        charts: {
            carrierPerformance: 'Performance by Carrier',
            topProducers: 'Top Producers',
            policies: 'policies',
            revenueTrend: 'Revenue Trend (6 months)'
        },
        errorLoading: 'Error loading analytics',
        vsPrevMonth: 'vs last month',
        pending: {
            title: 'Account Pending Approval',
            description: 'Thanks for registering your agency. To ensure the security and quality of our network, all agency accounts require manual validation or a demo.',
            nextSteps: 'Next Steps:',
            step1: 'Our team will review your NPN ({npn})',
            step2: 'We will contact you at your registered email',
            step3: 'Once approved, you will have full access',
            contactSupport: 'Contact Support',
            backHome: 'Back to Home'
        },
        loadCsv: 'Upload CSV',
        downloadPdf: 'Download PDF Report',
        pdfGenerated: 'PDF generated successfully',
        historicalOverview: 'Historical Overview',
        allTimeData: 'Accumulated data from all periods',
        allTime: 'All-time total',
        agents: 'agents'
    },
    // Agents
    agents: {
        title: 'My Agents',
        subtitle: 'Manage your producer team and their permissions',
        invite: 'Invite Agent',
        import: 'Bulk Import',
        searchPlaceholder: 'Search by name or email...',
        table: {
            agent: 'Agent',
            email: 'Email',
            status: 'Status',
            joined: 'Joined',
            actions: 'Actions'
        },
        status: {
            active: 'Active',
            pending: 'Pending'
        },
        empty: {
            title: 'No agents registered',
            description: 'Start by inviting your first agent or import a list.'
        },
        inviteDialog: {
            title: 'Invite New Agent',
            description: 'Send an email invitation for them to join your agency.',
            emailLabel: 'Email Address',
            send: 'Send Invitation',
            sending: 'Sending...'
        },
        importDialog: {
            title: 'Import Agents CSV',
            step1: 'Upload File',
            step2: 'Map Columns',
            step3: 'Preview',
            dragDrop: 'Drag and drop your CSV file here',
            selectFile: 'Select File'
        }
    },
    // Clients
    clients: {
        active: {
            title: 'Active Clients',
            subtitle: '{count} active clients total',
            stats: {
                total: 'Total Active',
                newThisMonth: 'New This Month',
                topCarrier: 'Top Carrier'
            }
        },
        canceled: {
            title: 'Canceled Clients',
            subtitle: '{count} canceled clients total',
            stats: {
                total: 'Total Canceled',
                canceledThisMonth: 'Canceled This Month'
            }
        },
        table: {
            searchPlaceholder: 'Search by name, email or phone...',
            allCarriers: 'All Carriers',
            allAgents: 'All Agents',
            headers: {
                client: 'Client',
                agent: 'Agent',
                email: 'Email',
                carrier: 'Carrier',
                policyId: 'Policy ID',
                startDate: 'Start Date',
                status: 'Status'
            },
            pagination: {
                showing: 'Showing {start} to {end} of {total}',
                page: 'Page {current} of {total}'
            },
            empty: {
                noResults: 'No results found',
                noClients: 'No clients found'
            }
        },
        status: {
            active: 'Active',
            inactive: 'Inactive',
            pending: 'Pending',
            canceled: 'Canceled'
        },
        actions: {
            refresh: 'Refresh',
            viewFull: 'View Full',
            history: 'History',
            notes: 'Notes',
            documents: 'Documents'
        }
    },
    // Profile
    profile: {
        title: 'My Account',
        subtitle: 'Manage your agency information',
        info: {
            title: 'Profile Information',
            subtitle: 'Update your agency photo and details'
        },
        form: {
            agencyName: 'Agency Name',
            npn: 'NPN (National Producer Number)',
            phone: 'Phone Number',
            email: 'Email Address',
            emailHelper: 'Email cannot be changed for security reasons'
        },
        save: 'Save Changes',
        saving: 'Saving...',
        account: {
            title: 'Account Information',
            type: 'Account Type',
            typeValue: 'Agency / Broker',
            status: 'Status',
            statusValue: 'Active Account',
            memberSince: 'Member since {date}'
        },
        success: 'Profile updated successfully',
        error: 'Error updating profile'
    },
    // Processor
    processor: {
        title: 'File Processor',
        subtitle: 'Import, process, and distribute leads and policies automatically',
        newProcess: 'New Process',
        steps: {
            upload: 'Upload',
            config: 'Configure',
            preview: 'Preview',
            process: 'Process',
            results: 'Results'
        },
        upload: {
            title: 'Upload your Carrier CSV file',
            description: 'Drag and drop your file here or click to browse.',
            button: 'Select CSV File',
            autoDetect: 'Auto-detect columns',
            cleaning: 'Data cleaning',
            mapping: 'Smart assignment',
            history: 'Secure history'
        },
        config: {
            title: 'Process Configuration',
            description: 'Define how to process this file and which carrier it belongs to',
            carrier: 'Carrier',
            insuranceType: 'Insurance Type',
            month: 'Report Month',
            year: 'Report Year',
            selectCarrier: 'Select Carrier',
            selectType: 'Select Type',
            selectMonth: 'Select Month',
            selectYear: 'Select Year',
            autoAssign: 'Automatic Assignment',
            autoAssignDesc: 'Assign clients to agents based on NPN from file',
            fileSummary: 'File Summary',
            rows: 'Rows',
            cols: 'Columns',
            size: 'Size',
            back: 'Back',
            continue: 'Continue to Preview'
        },
        status: {
            processing: 'Processing...',
            success: 'Processing successful',
            error: 'Processing error'
        }
    },
    // Landing & Public
    landing: {
        heroTitle: 'Fair Price. Total Access.',
        heroSubtitle: 'No complications. Choose your profile and get started.',
        agencyTitle: 'Agency PRO',
        agencyDescription: 'Total control for owners and administrators.',
        agencyPrice: '$39.99',
        agencyPriceUnit: '/month',
        agencyButton: 'Subscribe Agency',
        agentTitle: 'Independent Agent',
        agentDescription: 'Total transparency for producers.',
        agentPrice: '$39.99',
        agentFeatures: {
            portal: 'Personal Commission Portal',
            tracking: 'Real-Time Payment Tracking',
            history: 'Production History',
            alerts: 'Deposit Alerts'
        }
    },
    // Reconciliation
    reconciliation: {
        title: 'Commission Reconciliation',
        subtitle: 'Upload commission files and reconcile against your database',
        uploadTitle: 'Upload FMO CSV Report',
        mappingTitle: 'Map CSV Columns',
        steps: {
            upload: 'Upload File',
            mapping: 'Mapping',
            results: 'Results'
        },
        filters: {
            agent: 'Filter by Agent',
            carrier: 'Filter by Carrier',
            month: 'Month',
            year: 'Year',
            apply: 'Apply Filters',
            clear: 'Clear'
        },
        stats: {
            totalRows: 'Total Records',
            matched: 'Matched',
            unmatched: 'Unmatched',
            discrepancy: 'Discrepancy'
        },
        table: {
            policy: 'Policy',
            agent: 'Agent',
            client: 'Client',
            premium: 'Premium',
            carrier: 'Carrier',
            product: 'Product',
            effectiveDate: 'Effective Date',
            status: 'Status',
            commission: 'Commission',
            action: 'Action'
        },
        status: {
            matched: 'Matched',
            unmatched: 'Unmatched',
            discrepancy: 'Discrepancy',
            pending: 'Pending'
        },
        actions: {
            save: 'Save Reconciliation',
            new: 'New Reconciliation',
            download: 'Download Report',
            details: 'View Details'
        },
        toasts: {
            unsupportedFormat: 'Unsupported Format',
            useCsv: 'Please upload a CSV or Excel file',
            emptyFile: 'Empty File',
            fileLoaded: 'File loaded successfully',
            rowsFound: 'rows found',
            parseError: 'Error reading file',
            missingColumn: 'Missing required column',
            selectPolicyColumn: 'You must select the Policy Number column',
            configError: 'Configuration Error',
            userNotFound: 'User information not found',
            reconciliationSuccess: 'Perfect Reconciliation!',
            allPoliciesMatched: 'All policies appeared in the report',
            discrepanciesFound: 'unpaid policies detected',
            saveSuccess: 'Reconciliation saved successfully!',
            noDataToExport: 'No data to export'
        }
    },
    // Mappings
    mappings: {
        title: 'Configure Column Mappings',
        subtitle: 'Configure carrier column mappings so your agents can use these presets.',
        form: {
            insuranceType: 'Insurance Type',
            carrier: 'Select Carrier',
            name: 'Mapping Name (Optional)',
            namePlaceholder: 'Ex: Ambetter 2024',
            configured: 'Configured Mappings',
            statusField: 'Status Field',
            inactiveValues: 'Inactive Values'
        },
        alerts: {
            selectType: 'First select insurance type',
            selectCarrier: 'First select a carrier',
            noMappings: 'No mappings configured'
        },
        file: {
            upload: 'Drag and drop a CSV example file',
            description: 'We only need to see the columns, we won\'t process data',
            detected: 'Columns detected in your file:'
        },
        tips: {
            insuranceType: 'Select Insurance Type (Medicare, ACA or Private). Each type may have different mappings.',
            carrier: 'This mapping will be specific to this carrier. Your associated agents can use it.',
            name: 'Assign a custom name to this mapping for easy identification.',
            statusField: 'Select which CSV column indicates if the client is active or inactive',
            inactiveValues: 'Add values that appear in the status column when the client is inactive',
            customColumns: 'Add additional columns you want to capture from this carrier'
        },
        labels: {
            statusField: 'Status Field (Required)',
            inactiveValues: 'Values indicating Inactive Client',
            customColumns: 'Custom Columns',
            required: 'Required',
            newColumn: 'New Column',
            csvColumn: 'CSV Column Name',
            field: 'Field Name',
            addColumn: 'Add Column'
        },
        success: 'Mapping saved successfully'
    },
    // Rules
    rules: {
        title: 'Payment Rules',
        subtitle: 'Configure how commissions are calculated by carrier and product',
        newRule: 'New Rule',
        table: {
            insuranceType: 'Insurance Type',
            agent: 'Agent (NPN)',
            carrier: 'Carrier',
            state: 'State',
            product: 'Product',
            type: 'Type',
            payout: 'Agent Payout',
            allAgents: 'All Agents',
            internal: 'Internal Only',
            external: 'External Only',
            allProducts: 'All products',
            allStates: 'All'
        },
        dialog: {
            newTitle: 'New Payment Rule',
            editTitle: 'Edit Payment Rule',
            targetGroup: 'Apply rule to:',
            insuranceType: 'Insurance Type',
            carrier: 'Carrier',
            product: 'Product',
            wildcard: 'Apply to ALL products from this Carrier',
            state: 'State',
            calculationType: 'Calculation Type',
            agentValue: 'Agent Value',
            save: 'Save Rule'
        },
        empty: {
            title: 'No rules configured',
            description: 'Create your first rule to automatically calculate commissions',
            button: 'Create First Rule'
        },
        tips: {
            targetGroup: 'Define which agent group this rule applies to',
            insuranceType: 'Select Insurance Type (Medicare, ACA or Private)',
            agentNpn: 'Enter the NPN of the agent this specific rule applies to',
            product: 'If left empty, this rule ONLY applies when the Excel file has no product (NULL/Empty)',
            wildcard: 'The rule will apply to ALL products from this Carrier',
            state: 'If no state is selected, the rule applies to all states',
            remainder: 'The agency will automatically receive the remainder (Total - Agent Payout)',
            calcExampleFixed: 'Example: If there are 5 members and the rule is $10 per member, the agent receives $50 (5 × $10). The agency receives the rest.',
            calcExamplePercentage: 'Example: If total received is $100 and agent gets 70%, agent receives $70 and agency gets $30 automatically.'
        },
        form: {
            percentage: 'Percentage of Total (%)',
            fixed: 'Fixed per Member ($)',
            agentValue: 'Agent Value',
            selectAgentGroup: 'Select who to apply the rule to',
            selectState: 'Select a state (optional)'
        }
    },
    // Unassigned Agents
    unassigned: {
        title: 'Unregistered Agents',
        subtitle: 'Commissions from agents who do not yet have an account in the system',
        stats: {
            agents: 'Unregistered agents',
            total: 'Total accumulated',
            records: 'Pending records'
        },
        alert: {
            title: 'There are pending commissions to assign',
            description: 'These agents have processed commissions but are not registered. Invite them so they can view their payments.'
        },
        table: {
            npn: 'NPN',
            carriers: 'Carriers',
            records: 'Records',
            total: 'Total Accumulated',
            action: 'Action'
        },
        invite: 'Invite',
        listTitle: 'Agent List',
        toasts: {
            updated: 'Data updated',
            inviteSent: 'Invitation sent',
            inviteSentDesc: 'Invitation sent to agent with NPN',
            loadError: 'Error loading data'
        },
        empty: {
            title: 'All clear!',
            description: 'All agents with commissions are registered in the system'
        }
    },
    // Subscription Plans
    subscriptionPlans: {
        title: 'Subscription Plans',
        subtitle: 'Choose the plan that fits your needs',
        currentSubscription: 'Current Subscription',
        plan: 'Plan',
        expires: 'Expires',
        manageSubscription: 'Manage Subscription',
        status: {
            active: 'Active',
            trialing: 'Trialing',
            past_due: 'Past Due',
            canceled: 'Canceled',
            incomplete: 'Incomplete'
        },
        agentTitle: 'Independent Agent',
        agentDescription: 'Everything you need to manage your sales',
        agentPrice: '$39.99',
        agentPriceUnit: '/month',
        agentFeatures: {
            portal: 'Commission Portal',
            tracking: 'Payment Tracking',
            history: 'Full History',
            alerts: 'Email Alerts'
        },
        agentButton: 'Subscribe Now',
        agentButtonActive: 'Your Current Plan',
        agentButtonRedirecting: 'Redirecting...',
        agencyTitle: 'Partner Agency',
        agencyDescription: 'Tailored solutions for growing agencies',
        agencyPrice: 'Custom',
        agencyPriceSubtext: 'Contact for quote',
        agencyFeatures: {
            multiUser: 'Multi-User Management',
            import: 'Bulk Import',
            support: 'Priority Support',
            agents: 'Agent Management'
        },
        agencyButton: 'Request Access',
        footer: {
            guarantee: '30-day satisfaction guarantee.',
            cancel: 'Cancel anytime.'
        }
    },
    common: {
        loading: 'Loading...',
        error: 'Error',
        success: 'Success',
        cancel: 'Cancel',
        save: 'Save',
        delete: 'Delete',
        edit: 'Edit',
        close: 'Close',
        unknown: 'Unknown',
        selectFile: 'Select File',
        dragDrop: 'Drag and drop your file here',
        processing: 'Processing...',
        back: 'Back',
        upload: 'Upload',
        refresh: 'Refresh',
        agencyNotFound: 'Agency not found'
    },
    // Landing Page (public)
    landingNav: {
        login: 'Login',
        register: 'Register',
        features: 'Features',
        pricing: 'Pricing',
        contact: 'Contact'
    },
    hero: {
        titleStart: 'The Ultimate Platform for',
        titleHighlight: 'Commission Reconciliation',
        subtitle: 'Master your finances, eliminate errors, and automate reconciliation. Consoliday transforms Excel chaos into financial clarity in seconds.',
        ctaPrimary: 'Get Started',
        ctaSecondary: 'View Demo'
    },
    features: {
        title: 'Why Choose Consoliday?',
        subtitle: 'Designed by insurance experts for agencies and agents.',
        f1Title: 'Automatic Reconciliation',
        f1Desc: 'Upload commission files and let our smart engine find discrepancies instantly.',
        f2Title: 'Agent Management',
        f2Desc: 'Centralize team info, assign hierarchy levels, and control downstream payments easily.',
        f3Title: 'Real-Time Reports',
        f3Desc: 'Visualizing revenue, projections, and payment status with interactive dashboards.',
        f4Title: 'Bank-Grade Security',
        f4Desc: 'Your data is protected with state-of-the-art encryption and privacy compliance.'
    },
    pricing: {
        title: 'Transparent Plans',
        subtitle: 'Choose the plan that fits your growth.',
        month: '/mo',
        popular: 'POPULAR',
        agency: {
            title: 'Agency',
            price: 'Contact Us',
            features: [
                'Comprehensive Management Platform',
                'Incentivize Agent Productivity',
                'Real-Time Sales Monitoring',
                'Hierarchical Team Management',
                'Automatic Consolidated Reports'
            ],
            btn: 'Request Demo'
        },
        agent: {
            title: 'Independent Agent',
            price: '$39.99',
            features: [
                'Personal dashboard',
                'Own commission tracking',
                'Payment alerts',
                'Policy history',
                'Email support'
            ],
            btn: 'Start Now'
        }
    },
    footer: {
        rights: 'All rights reserved.',
        privacy: 'Privacy',
        terms: 'Terms'
    }
};
